import { SelectOption } from '@/components/Form/src/types'
import { commonEnums } from './commonEnum'

const Gender: SelectOption[] = [
  {
    value: commonEnums.Gender.Male,
    label: 'Male'
  },
  {
    value: commonEnums.Gender.Female,
    label: 'Female'
  }
]

const Status: SelectOption[] = [
  {
    value: commonEnums.Status.Active,
    label: 'Active'
  },
  {
    value: commonEnums.Status.Inactive,
    label: 'Inactive'
  }
]

const CorrespondingAddress: SelectOption[] = [
  {
    value: commonEnums.CorrespondingAddress.Home,
    label: 'Home'
  },
  {
    value: commonEnums.CorrespondingAddress.Office,
    label: 'Office'
  }
]
const Type: SelectOption[] = [
  {
    value: 2,
    label: 'Clinical Audit Programme'
  },
  {
    value: 1,
    label: 'Quality Assurance'
  }
]
const YesorNo: SelectOption[] = [
  {
    label: 'Yes',
    value: commonEnums.YesorNo.Yes
  },
  {
    label: 'No',
    value: commonEnums.YesorNo.No
  }
]
const YesorNoorNa: SelectOption[] = [
  {
    label: 'Yes',
    value: commonEnums.YesorNo.Yes
  },
  {
    label: 'No',
    value: commonEnums.YesorNo.No
  },
  {
    label: 'N/A',
    value: commonEnums.YesorNo.Na
  }
]
const LongorShort: SelectOption[] = [
  {
    label: 'Short Case',
    value: commonEnums.LongorShort.Short
  },
  {
    label: 'Long Case',
    value: commonEnums.LongorShort.Long
  }
]

export const commonOptions = {
  Gender,
  Status,
  Type,
  CorrespondingAddress,
  YesorNo,
  YesorNoorNa,
  LongorShort
}
